var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    { attrs: { label: "経験業種・希望業種", "has-child": "" } },
    [
      _c("div", { staticClass: "boss-table-2-layout" }, [
        _c(
          "div",
          {
            staticClass: "boss-table-2-item boss-table-2-item-body",
            class: {
              "is-modified":
                _vm.desiredBusinesses.length ||
                _vm.experiencedBusinesses.length,
            },
          },
          [
            _c("div", { staticClass: "boss-separated-small" }, [
              _c(
                "div",
                {
                  staticClass:
                    "boss-layout boss-layout-start boss-layout-gap-large",
                },
                _vm._l(_vm.options, function (option, i) {
                  return _c(
                    "label",
                    {
                      key: i,
                      staticClass: "pega-input",
                      attrs: { "data-test": "label-" + i },
                    },
                    [
                      _c("input", {
                        staticClass: "boss-input-checkbox",
                        attrs: { "data-test": "radio-" + i, type: "radio" },
                        domProps: {
                          checked: _vm.selectedOption === option.key,
                          value: option.key,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit(
                              "update:selectedOption",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(_vm._s(option.label) + "\n          "),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "boss-table-2-layout",
          attrs: { "data-test": "experienced-occupation" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact",
            },
            [_vm._v("\n      経験業種\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "boss-table-2-item boss-table-2-item-body",
              class: { "is-modified": _vm.experiencedBusinesses.length },
              attrs: { "data-test": "experienced-occupation-body" },
            },
            [
              _vm.businessesMaster.length > 0
                ? _c("select-modal-button", {
                    attrs: {
                      "master-data": _vm.businessesMaster,
                      "selected-items": _vm.experiencedBusinesses.map(function (
                        b
                      ) {
                        return { id: b, experience: "" }
                      }),
                      title: "業種",
                      suffix: "experienced-businesses",
                      "data-test": "experienced-businesses-modal",
                    },
                    on: {
                      "update-modal-checked-ids": function (value) {
                        return _vm.$emit(
                          "update:experiencedBusinesses",
                          value.map(function (b) {
                            return b.id
                          })
                        )
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "boss-table-2-layout",
          attrs: { "data-test": "desired-occupation" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact",
            },
            [_vm._v("\n      希望業種\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "boss-table-2-item boss-table-2-item-body",
              class: { "is-modified": _vm.desiredBusinesses.length },
              attrs: { "data-test": "desired-occupation-body" },
            },
            [
              _c("label", { staticClass: "boss-checkbox" }, [
                _c("input", {
                  staticClass: "boss-input-checkbox",
                  attrs: { type: "checkbox", "data-test": "check-box" },
                  domProps: { checked: _vm.containBusinessesNonHopeUser },
                  on: {
                    change: function ($event) {
                      return _vm.$emit(
                        "update:containBusinessesNonHopeUser",
                        $event.target.checked
                      )
                    },
                  },
                }),
                _vm._v("希望業種を「未入力」としている会員を含む\n      "),
              ]),
              _vm._v(" "),
              _vm.businessesMaster.length > 0
                ? _c("select-modal-button", {
                    attrs: {
                      "master-data": _vm.businessesMaster,
                      "selected-items": _vm.desiredBusinesses.map(function (b) {
                        return { id: b, experience: "" }
                      }),
                      title: "業種",
                      suffix: "desired-businesses",
                      "data-test": "desired-businesses-modal",
                    },
                    on: {
                      "update-modal-checked-ids": function (value) {
                        return _vm.$emit(
                          "update:desiredBusinesses",
                          value.map(function (b) {
                            return b.id
                          })
                        )
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }